import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import { Dialog as MuiDialog } from '@material-ui/core'
import styled from 'styled-components'

export const Dialog = styled(MuiDialog)`
  // increase z-index so it overlays the other modal it is rendered over
  && {
    z-index: 10001 !important;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 464px;
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px 24px;
`

export const ModalHeader = styled.div`
  width: 100%;
  border-radius: 4px 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 24px 24px 16px 24px;
`

export const ModalTitle = styled.h3`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 20px;
  font-weight: 600;
  color: #172b4d;
  margin: auto 0 auto 0;
  @media (min-width: 600px) {
    max-width: 85%;
  }
`
export const ModalCloseButton = styled.button`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  border: none;
  color: #637381;
`
export const ModalNoButton = styled(SecondaryButton)`
  width: 190px;
  border: 1px solid black;
  margin: 10px 16px 0 0;
  white-space: nowrap;
  @media (min-width: 600px) {
    width: 190px;
  }
`

export const ModalYesButton = styled(ModalNoButton)`
  background: ${({ theme }) => theme.colors.brand.blue};
  border: none;
  color: ${({ theme }) => theme.colors.brand.white};
  @media (min-width: 600px) {
    width: 190px;
  }
`

export const ModalText = styled.p`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.17;
  color: #637381;
  margin: 0 0 16px 0;
  @media (min-width: 600px) {
    max-width: 85%;
  }
`

export const ModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 500px) {
    flex-direction: row;
  }
`
